(() => {
    const inputSelector = 'input[name="selling_plan"]';
    const textSelector = '.subscription-unit-price';

    function toggleTextVisibility(input, textElements) {
        const shouldHide = !input.value || input.value === "null";
        textElements.forEach(el => {
            el.style.display = shouldHide ? 'none' : '';
        });
    }

    function waitForInputAndInit() {
        const sellingPlanInput = document.querySelector(inputSelector);
        const textElements = Array.from(document.querySelectorAll(textSelector));

        if (!sellingPlanInput || textElements.length === 0) {
            setTimeout(waitForInputAndInit, 100);
            return;
        }

        toggleTextVisibility(sellingPlanInput, textElements);

        sellingPlanInput.addEventListener('input', () => toggleTextVisibility(sellingPlanInput, textElements));

        const observer = new MutationObserver(() => toggleTextVisibility(sellingPlanInput, textElements));
        observer.observe(sellingPlanInput, { attributes: true, attributeFilter: ['value'] });
    }

    waitForInputAndInit();
})();